import React from "react";
import "styled-components/macro";
import NavBar from "../../component/NavBar";
import PlanDetails from "./component/PlanDetails";

import Banner1 from "../../assets/images/19682.png";
import Banner2 from "../../assets/images/1968.png";
import Banner3 from "../../assets/images/19683.png";

import {
  BackImage,
  BlueText,
  Input,
  Statement,
  SubStatement,
  SubTitle,
  Title,
} from "./Final.style";

function Final() {
  return (
    <div>
      <NavBar />
      <div
        className="container"
        style={{ marginTop: "130px" }}
        css={`
          height: fit-content;
        `}
      >
        <div className="row" style={{ padding: "0px 45px" }} css={`display: flex;`}>
          <div
            className="col-md-6"
            css={`
              height: 600px !important;
            `}
          >
            <Title>
              Hey, User
              <br />
              Here's your Term Insurance Recommendation.
            </Title>

            <SubTitle>Tailored as per your needs!</SubTitle>

            <Statement>
              On the basis of your inputs, we recommend a Sum Assured of
              <BlueText> ₹2,08,32,021</BlueText> for a Policy Term of
              <BlueText> 38</BlueText> Years.
            </Statement>
            <SubTitle style={{ fontWeight: "bold" }}>
              The estimated rate of this coverage is between ₹6123.8 and ₹7106
              per month.
            </SubTitle>
            <SubStatement>
              I already have a Sum Assured of ₹ <Input /> in mind, take me to
              <BlueText> quotes.</BlueText>{" "}
            </SubStatement>

            <BackImage src={Banner1} />
            <BackImage
              src={Banner2}
              css={`
                left: -90px !important;
                top: -100px !important;
                width: 100px !important;
              `}
            />
            <BackImage
              src={Banner3}
              css={`
                left: 297px !important;
                top: -489px !important;
                width: 270px !important;
              `}
            />
          </div>
          <div
            className="col-md-6"
            css={`
              height: fit-content;
            `}
          >
            <PlanDetails />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Final;
